export const capitalize = <T extends string>(str: T): Capitalize<T> =>
  (str.charAt(0).toUpperCase() + str.slice(1)) as Capitalize<T>

export const capitalizeAll = <T extends string>(str: T): Capitalize<T> =>
  capitalize(str.replace(/( \w)/gi, (c) => c.toUpperCase()) as Capitalize<T>)
